import { put, takeEvery, select } from "redux-saga/effects";
import { UPDATE_ALERT_STATUS_REQUEST } from "../constants/constants";
import { UPDATE_ALERTS_STATUS_URL } from "../constants/constants";
import { getService, getAxiosHeaders } from "../../library/RestAPI";
import {
  CLEAR_SYS_GUARD_ALERT_INFO_DATA,
  GET_SYS_GUARD_POPUP_DATA,
  GET_SYS_GUARD_SIDE_POPUP_DATA,
  OPEN_SYS_GUARD_SNACKBAR,
  SET_SYS_GUARD_PAGE_LOADER,
} from "../../features/SysGuard/sysGuardConstants";
import { GET_COMPLIANCE_STATE_DATA } from '../../features/Compliance/complianceConstants';

function* updateAlertStatus(action) {
  const { status, sysGuardData, loc: location, isCompliance, reason, tillDate } = action.payload;
  let options;
  let errorInfo;
  let url;
  const handleServerError = (errorData) => {
    errorInfo = errorData;
  };
  if (sysGuardData) {
  yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: true});
  }
  if (status === "MARK_ACCEPT_RISK") {
    url = `${UPDATE_ALERTS_STATUS_URL}/${action.payload.status}?acceptedTill=${tillDate}&reason=${reason}`;
  } else if (status === "MARK_FALSE_POSITIVE") {
    url = `${UPDATE_ALERTS_STATUS_URL}/${action.payload.status}?acceptedTill=${tillDate}`;
  } else {
    url = `${UPDATE_ALERTS_STATUS_URL}/${action.payload.status}`;
  }
  try {
    options = {
      method: "PUT",
      url: url,
      headers: getAxiosHeaders(true),
      data: action.payload.ids,
    };
    try {
      if (action.payload.ids.length !== 0) {
        const res = yield getService(options, handleServerError);
        if (res && res.status === 204) {
          if (isCompliance) {
            const selectedSiteFromStore = yield select(state => state.ComplianceReducer.selectedSite);
            yield put({ type: GET_COMPLIANCE_STATE_DATA, payload: { selectedSite: selectedSiteFromStore } });
          }
          yield put({ type: "UPDATE_ALERT_STATUS_SUCCEEDED", payload: status });
          if (sysGuardData) {
            yield put({ type: OPEN_SYS_GUARD_SNACKBAR, payload: true});
            yield put({
              type: GET_SYS_GUARD_POPUP_DATA,
              payload: sysGuardData,
            });
            if (location !== "locationBasedUsers") {
              yield put({
                type: GET_SYS_GUARD_SIDE_POPUP_DATA,
                payload: sysGuardData,
              });
            }
            yield put({ type: CLEAR_SYS_GUARD_ALERT_INFO_DATA });
            yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false});
          }
        } else {
          let errorMessage = "";
          // handling server errors ifor create alert
          if (errorInfo && errorInfo.errorMessage) {
            errorMessage = errorInfo.errorMessage;
          } else {
            errorMessage = "Update unsuccessful";
          }
          yield put({
            type: "UPDATE_ALERT_STATUS_FAILED",
            payload: errorMessage,
          });
        }
      }
    } catch (error) {
      console.log(error);
      // myStorage.setItem("access_token", "error");
      yield put({
        type: "UPDATE_ALERT_STATUS_FAILED",
        payload: "Error Fetching Data from API",
      });
      if (sysGuardData) {
        yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false});
        }
    }
  } catch (e) {
    yield put({ type: "UPDATE_ALERT_STATUS_FAILED" });
    if (sysGuardData) {
      yield put({ type: SET_SYS_GUARD_PAGE_LOADER, payload: false});
      }
  }
}

function* changeAlertStatusSaga() {
  yield takeEvery(UPDATE_ALERT_STATUS_REQUEST, updateAlertStatus);
}

export default changeAlertStatusSaga;
